import type { IconGlyph } from '../icon';

/**
 * Tractie `user` glyph (medium, 24×24).
 *
 * Source: `@tractie/icons` v1.2.1, `dist/jsx/m/user.jsx`. Older than the
 * v1.5.0 of `star.ts`.
 */
export const iconUser: IconGlyph = {
  name: 'user',
  path: 'M12 12c2.21 0 4-1.79 4-4V6c-.01-2.17-1.84-4-4-4S8 3.83 8 6v2c0 2.21 1.79 4 4 4M9 6c.01-1.62 1.38-3 3-3s3 1.37 3 3v2c0 1.63-1.37 3-3 3S9 9.63 9 8zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5c1.92 0 4 1.53 4 4v3H4v-3c0-2.47 2.08-4 4-4 .28 0 .5-.22.5-.5S8.28 13 8 13c-2.4 0-5 1.91-5 5v4h18v-4c0-3.09-2.6-5-5-5',
};
